<template>
  <div>
    <soha-modal
      id="jobseeker-register"
      :title="
        jobseekerRegistred ? completeStepName : $t(`${I18nPrefix}REGISTER`)
      "
      @hide="clearDataModal()"
      :noCloseBackDrop="jobseekerRegistred"
      :noCloseEsc="jobseekerRegistred"
      :hideClose="jobseekerRegistred"
    >
      <template v-slot:body>
        <div v-if="!jobseekerRegistred">
          <div v-if="!sentCode">
            <soha-text-field
              @onEnterPressed="sendRegisterCode()"
              v-model="firstName.value"
              :error="firstName.error"
              name="firstName"
              :placeholder="$t(`${I18nPrefix}FIRST_NAME`)"
              class="w-100"
            />
            <soha-text-field
              @onEnterPressed="sendRegisterCode()"
              v-model="lastName.value"
              :error="lastName.error"
              name="lastName"
              :placeholder="$t(`${I18nPrefix}LAST_NAME`)"
              class="w-100"
            />
            <soha-text-field
              @onEnterPressed="sendRegisterCode()"
              name="username"
              v-model="mobile.value"
              :error="mobile.error"
              type="number"
              :placeholder="$t(`${I18nPrefix}MOBILE`)"
              class="w-100"
              autocomplete="new-mobile"
              :maxLength="11"
            />
            <soha-select
              class="w-100"
              :placeholder="$t(`${I18nPrefix}GENDER`)"
              :options="gendersUpdate"
              v-model="genderId"
            />
            <soha-text-field
              :placeholder="$t(`${I18nPrefix}BIRTH_DATE`)"
              class="w-100 birth-date"
              v-model="birthDate"
              icon="date"
              icon-position="left"
              icon-cursor
              icon-color="secondary"
              :readonly="true"
            />
            <soha-date-picker
              v-model="birthDate"
              custom-input=".birth-date"
              simple
            />
            <soha-text-field
              @onEnterPressed="sendRegisterCode()"
              v-model="email.value"
              :error="email.error"
              name="email"
              :placeholder="$t(`${I18nPrefix}EMAIL`)"
              class="w-100"
            />
            <soha-text-field
              @onEnterPressed="sendRegisterCode()"
              v-model="password.value"
              :error="password.error"
              name="password"
              :type="showPass ? 'text' : 'password'"
              :icon="showPass ? 'hidden' : 'eye'"
              icon-position="left"
              icon-cursor
              @onIconClicked="showPass = !showPass"
              :placeholder="$t(`${I18nPrefix}PASSWORD_PLACEHOLDER`)"
              class="w-100"
              autocomplete="new-password"
            />
            <soha-text-field
              @onEnterPressed="sendRegisterCode()"
              v-model="repeatePassword.value"
              :error="repeatePassword.error"
              name="password"
              :type="showPassRepeate ? 'text' : 'password'"
              :icon="showPassRepeate ? 'hidden' : 'eye'"
              icon-position="left"
              icon-cursor
              @onIconClicked="showPassRepeate = !showPassRepeate"
              :placeholder="$t(`${I18nPrefix}REPEATE_PASSWORD_PLACEHOLDER`)"
              class="w-100"
              autocomplete="new-repeate-password"
            />
          </div>
          <div v-else>
            <div class="w-100 mb-1">
              {{ $t(`${I18nPrefix}CODE`) }} {{ $t(`${I18nPrefix}TO_NUMBER`) }}
              <span class="secondary-color font-weight-bolder">
                {{ toPersianDigits(mobile.value) }}
              </span>
              {{ $t(`${I18nPrefix}SENT`) }}.
              <span
                class="secondary-color cursor-pointer"
                @click="sentCode = false"
              >
                {{ $t(`${I18nPrefix}CHANGE_NUMBER`) }}
              </span>
            </div>
            <soha-text-field
              @onEnterPressed="register()"
              v-model="registerCode.value"
              :error="registerCode.error"
              name="registerCode"
              :placeholder="$t(`${I18nPrefix}CODE`)"
              class="w-100"
              type="number"
            />
            <div class="w-100 mb-4">
              <span style="color: var(--disable-secondary-color)" v-if="timer">
                {{ resendTime }} {{ $t(`${I18nPrefix}UP_TO`) }}
                {{ $t(`${I18nPrefix}RESEND_CODE`) }}
              </span>
              <span
                v-else
                @click="sendRegisterCode(true)"
                class="ml-1"
                :style="
                  codeLoading
                    ? 'color: var(--disable-secondary-color)'
                    : 'color: var(--secondary-color); cursor: pointer'
                "
              >
                {{ $t(`${I18nPrefix}RESEND_CODE`) }}
              </span>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-if="completeResumeStep == 1">
            <soha-checkbox
              class="mb-2"
              :label="$t(`${I18nPrefix}NO_EDUCATIONAL`)"
              checkboxId="noEducational"
              v-model="noEducational"
              name="noEducational"
            />
            <soha-select
              class="w-100 my-2"
              :placeholder="$t(`${I18nPrefix}DEGREE`)"
              :options="degries"
              v-model="resumeResult.educationalBackground[0].educationDegree"
              :disabled="noEducational"
            />
            <soha-text-field
              :placeholder="$t(`${I18nPrefix}MAJOR`)"
              class="w-100"
              v-model="resumeResult.educationalBackground[0].educationMajor"
              :disabled="noEducational"
            />
            <soha-text-field
              :placeholder="$t(`${I18nPrefix}UNIVERSITY`)"
              class="w-100"
              v-model="
                resumeResult.educationalBackground[0].educationUniversity
              "
              :disabled="noEducational"
            />
          </div>
          <div v-if="completeResumeStep == 2">
            <soha-checkbox
              class="mb-2"
              :label="$t(`${I18nPrefix}NO_JOB`)"
              checkboxId="noJob"
              v-model="noJob"
              name="noJob"
            />
            <soha-text-field
              v-model="resumeResult.jobExperience[0].jobTitle"
              name="jobTitle"
              :placeholder="$t(`${I18nPrefix}JOB_TITLE`)"
              class="w-100"
              :disabled="noJob"
            />

            <soha-text-field
              v-model="resumeResult.jobExperience[0].jobCompanyName"
              name="firstName"
              :placeholder="$t(`${I18nPrefix}COMPANY_NAME`)"
              class="w-100"
              :disabled="noJob"
            />

            <soha-text-field
              :placeholder="$t(`${I18nPrefix}START_DATE`)"
              class="w-100 jobStartDate"
              v-model="resumeResult.jobExperience[0].jobStartDate"
              icon="date"
              icon-position="left"
              icon-cursor
              icon-color="secondary"
              :readonly="true"
              :disabled="noJob"
            />
            <soha-date-picker
              v-model="resumeResult.jobExperience[0].jobStartDate"
              custom-input=".jobStartDate"
              simple
              type="year-month"
              :disabled="noJob"
            />

            <soha-text-field
              :placeholder="$t(`${I18nPrefix}END_DATE`)"
              class="w-100 jobEndDate"
              v-model="resumeResult.jobExperience[0].jobEndDate"
              icon="date"
              icon-position="left"
              icon-cursor
              icon-color="secondary"
              :readonly="true"
              :disabled="isCurrentlyEmployed || noJob"
            />
            <soha-date-picker
              v-model="resumeResult.jobExperience[0].jobEndDate"
              custom-input=".jobEndDate"
              simple
              type="year-month"
              :disabled="isCurrentlyEmployed || noJob"
            />
            <soha-checkbox
              class="mt-2"
              :label="$t(`${I18nPrefix}IS_EMPLOYED`)"
              checkboxId="isCurrentlyEmployed"
              v-model="isCurrentlyEmployed"
              name="isCurrentlyEmployed"
            />
          </div>
          <div v-if="completeResumeStep == 3">
            <soha-checkbox
              class="mb-2"
              :label="$t(`${I18nPrefix}NO_SKILL`)"
              checkboxId="noSkill"
              v-model="noSkill"
              name="noSkill"
            />
            <div v-for="(skill, index) in resumeResult.skill" :key="index">
              <span
                v-if="resumeResult.skill.length > 1"
                class="svg svg-icon svg-icon-red cursor-pointer position-absolute right-0"
                @click="resumeResult.skill.splice(index, 1)"
              >
                <inline-svg src="/media/svg/soha/icons/times.svg" />
              </span>
              <soha-text-field
                :placeholder="$t(`${I18nPrefix}SKILL_TITLE`)"
                class="w-100"
                v-model="skill.skillTitle"
                :disabled="noSkill"
              />
              <soha-select
                class="w-100 my-2"
                :placeholder="$t(`${I18nPrefix}LEVEL`)"
                :options="levels"
                v-model="skill.skillLevelId"
                :disabled="noSkill"
              />
              <div
                class="w-100 my-2"
                v-if="
                  resumeResult.skill.length > 1 &&
                  index != resumeResult.skill.length - 1
                "
              >
                <soha-divider />
              </div>
            </div>
            <soha-add-new-item
              @addNewItem="resumeResult.skill.push({})"
              :text="$t(`${I18nPrefix}ADD_SKILL`)"
              icon="plus"
              v-if="!noSkill"
            />
          </div>
        </div>
      </template>

      <template v-slot:footer>
        <soha-button
          v-if="!jobseekerRegistred"
          :loading="btnLoading"
          name="sendResume"
          :text="$t(`${I18nPrefix}REGISTER`)"
          class="mx-auto w-100"
          @click="handleAuthenticationAction()"
        />
        <div class="row w-100" v-else>
          <div class="col-6" v-if="completeResumeStep != 1">
            <soha-button
              name="completeResume"
              :text="$t(`${I18nPrefix}BACK`)"
              class="mx-auto w-100"
              @click="completeResumeStep--"
              outline
              variant="danger"
            />
          </div>
          <div :class="completeResumeStep == 1 ? 'col-12' : 'col-6'">
            <soha-button
              :loading="updateResumeLoading"
              name="completeResume"
              :text="
                completeResumeStep == 3
                  ? $t(`${I18nPrefix}INSERT`)
                  : $t(`${I18nPrefix}CONTINUE`)
              "
              class="mx-auto w-100"
              @click="handleCompleteResume()"
            />
          </div>
        </div>
      </template>
    </soha-modal>

    <soha-modal
      id="resume-confirm"
      :title="$t(`${I18nPrefix}RESUME_CONFIRM`)"
      @hide="clearDataModal()"
      :noCloseBackDrop="jobseekerRegistred"
      :noCloseEsc="jobseekerRegistred"
      :hideClose="jobseekerRegistred"
    >
      <template v-slot:body>
        <p
          class="text-justify font-size-h5 line-height-xl"
          v-html="$t(`${I18nPrefix}CONFIRM_MODAL_MESSAGE`)"
        />
      </template>

      <template v-slot:footer>
        <div class="d-flex justify-content-between w-100">
          <soha-button
            variant="danger"
            outline
            name="rejectResume"
            :text="$t(`${I18nPrefix}NO`)"
            @click="rejectResume()"
          />
          <soha-button
            :loading="confirmLoading"
            name="confirmResume"
            :text="$t(`${I18nPrefix}YES`)"
            @click="confirmResume()"
          />
        </div>
      </template>
    </soha-modal>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import UIMixin from "@/mixins/UIMixin";
import GeneralMixin from "@/mixins/GeneralMixin";
import ValidationMixin from "@/mixins/ValidationMixin";
import { mapGetters } from "vuex";

export default {
  props: {
    currentMobile: null,
  },

  mixins: [UIMixin, ValidationMixin, GeneralMixin],

  data() {
    return {
      I18nPrefix: "JOB_SEEKER.COMPONENTS.AUTH.REGISTER.",
      sentCode: false,
      btnLoading: false,
      codeLoading: false,
      confirmLoading: false,
      jobseekerRegistred: false,
      registerCode: {
        value: null,
        error: null,
      },
      timer: null,
      timeRemaining: 0,

      mobile: {
        value: null,
        error: null,
      },
      firstName: {
        value: null,
        error: null,
      },
      lastName: {
        value: null,
        error: null,
      },
      email: {
        value: null,
        error: null,
      },
      password: {
        value: null,
        error: null,
      },
      repeatePassword: {
        value: null,
        error: null,
      },
      genderId: null,
      birthDate: null,

      showPass: false,
      showPassRepeate: false,

      noEducational: false,
      noJob: false,
      noSkill: false,
      isCurrentlyEmployed: false,
      updateResumeLoading: false,
      completeResumeStep: 1,
      degries: [
        { id: 28, text: "دیپلم" },
        { id: 29, text: "کاردانی " },
        { id: 30, text: "کارشناسی" },
        { id: 31, text: "کارشناسی ارشد" },
        { id: 32, text: "دکترا" },
        { id: 122, text: "سایر" },
      ],
      levels: [
        { id: 16, text: "مبتدی" },
        { id: 17, text: "متوسط" },
        { id: 18, text: "خوب" },
        { id: 19, text: "عالی" },
      ],
      gendersUpdate: [
        { id: 1, text: "زن" },
        { id: 2, text: "مرد" },
      ],
      resumeResult: {
        contact: [{}],
        course: [],
        educationalBackground: [
          {
            educationMajor: null,
            educationDegree: null,
            educationUniversity: null,
          },
        ],
        honor: [],
        jobExperience: [
          {
            jobTitle: null,
            jobCompanyName: null,
            jobStartDate: null,
            jobEndDate: null,
          },
        ],
        language: [],
        personalData: [],
        project: [],
        skill: [
          {
            skillTitle: null,
            skillLevelId: null,
          },
        ],
        companyId: "0",
        jobId: "0",
        visitorId: null,
      },
    };
  },

  methods: {
    clearDataModal() {
      this.$emit("closeModal");
      this.mobile = {
        value: null,
        error: null,
      };
      this.firstName = {
        value: null,
        error: null,
      };
      this.lastName = {
        value: null,
        error: null,
      };
      this.email = {
        value: null,
        error: null,
      };
      this.repeatePassword = {
        value: null,
        error: null,
      };
      this.password = {
        value: null,
        error: null,
      };
      this.registerCode = {
        value: null,
        error: null,
      };
      this.genderId = null;
      this.birthDate = null;

      this.btnLoading = false;
      this.codeLoading = false;

      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      this.resumeResult = {
        contact: [{}],
        course: [],
        educationalBackground: [
          {
            educationMajor: null,
            educationDegree: null,
            educationUniversity: null,
          },
        ],
        honor: [],
        jobExperience: [
          {
            jobTitle: null,
            jobCompanyName: null,
            jobStartDate: null,
            jobEndDate: null,
          },
        ],
        language: [],
        personalData: [],
        project: [],
        skill: [
          {
            skillTitle: null,
            skillLevelId: null,
          },
        ],
        companyId: "0",
        jobId: "0",
        visitorId: null,
      };
      this.completeResumeStep = 1;
    },

    handleAuthenticationAction() {
      if (!this.sentCode) {
        return this.sendRegisterCode();
      }
      this.register();
    },

    register() {
      this.registerCode.error = this.validateField(
        this.registerCode.value,
        this.$t(`${this.I18nPrefix}CODE`)
      );
      if (this.registerCode.error) return;

      this.btnLoading = true;
      ApiService.post("api/v2/jobseeker/register-with-resume", {
        username: this.mobile.value,
        firstname: this.firstName.value,
        lastname: this.lastName.value,
        email: this.email.value,
        password: this.password.value,
        genderId: this.genderId,
        birthDate: this.birthDate,
        code: this.registerCode.value,
      })
        .then((data) => {
          if (!data.data.code) {
            const expiresIn =
              Math.floor(new Date().getTime() / 1000) + data.data.expires_in;
            this.$store.commit("setJobseekerAuth", {
              token: data.data.access_token,
              expiresIn: expiresIn,
              refreshToken: data.data.refresh_token,
            });
            if (!data.data.hasResume) {
              this.jobseekerRegistred = true;
              this.getResume();
            } else this.$bvModal.show("resume-confirm");
          } else if (data.data.code == 102)
            this.email.error = data.data.message;
          else this.errorToast(data.data.message);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },

    registerDataNotValid() {
      this.email.error = null;
      this.mobile.error = this.validatePhoneNumber(this.mobile.value);
      this.firstName.error = this.validateField(
        this.firstName.value,
        this.$t(`${this.I18nPrefix}FIRST_NAME`)
      );
      this.lastName.error = this.validateField(
        this.lastName.value,
        this.$t(`${this.I18nPrefix}LAST_NAME`)
      );
      this.password.error = this.validatePassword(
        this.password.value,
        this.$t(`${this.I18nPrefix}PASSWORD_PLACEHOLDER`)
      );
      this.repeatePassword.error = this.validatePassword(
        this.repeatePassword.value,
        this.$t(`${this.I18nPrefix}REPEATE_PASSWORD_PLACEHOLDER`)
      );
      if (this.password.value !== this.repeatePassword.value) {
        this.repeatePassword.error = this.$t(
          `${this.I18nPrefix}WRONG_REPEAT_PASSWORD_ERR`
        );
      }
      return (
        this.mobile.error ||
        this.firstName.error ||
        this.lastName.error ||
        this.password.error ||
        this.repeatePassword.error ||
        this.email.error
      );
    },

    handleCompleteResume() {
      if (this.completeResumeStep != 3) this.completeResumeStep++;
      else this.updateResume();
    },

    updateResume() {
      ApiService.setHeader("jobseeker");
      this.updateResumeLoading = true;
      this.resumeResult.personalData = [this.jobseekerResume.personalData];
      let formData = new FormData();
      formData.append("imageUser", null);
      formData.append("file", null);
      formData.append(
        "result",
        JSON.stringify(this.removeEmptyResumeFields(this.resumeResult))
      );
      ApiService.post("api/v2/jobseeker/resume", formData).then((data) => {
        if (data.data.code == 204) {
          this.successToast(data.data.message);
          this.getResume();
          this.$emit("completeRegister", "newResume");
          this.$bvModal.hide("jobseeker-register");
        } else {
          this.errorToast(data.data.message);
        }
        this.updateResumeLoading = false;
      });
    },

    async sendRegisterCode(resend) {
      if (this.registerDataNotValid()) return;

      this.codeLoading = resend;
      this.btnLoading = !resend;

      try {
        const res = await ApiService.post(
          "/api/v2/jobseeker/send-authorize-code",
          { username: this.mobile.value }
        );

        if (res.data.code == 200) {
          this.successToast(res.data.message);
          this.startTimer(120);
          this.sentCode = true;
        } else {
          this.errorToast(res.data.message);
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }
      } finally {
        this.codeLoading = false;
        this.btnLoading = false;
      }
    },

    startTimer(duration) {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      this.timeRemaining = duration;
      this.timer = setInterval(() => {
        if (this.timeRemaining > 0) {
          this.timeRemaining--;
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },

    removeEmptyResumeFields(obj) {
      for (const key in obj) {
        if (Array.isArray(obj[key])) {
          obj[key] = obj[key].every(
            (item) =>
              typeof item === "object" &&
              Object.keys(item).length > 0 &&
              Object.values(item).every((value) => !value)
          )
            ? []
            : obj[key];
        }
      }
      return obj;
    },

    getResume() {
      ApiService.setHeader("jobseeker");
      ApiService.get("api/v2/jobseeker/resume").then((data) => {
        this.$store.commit("saveJobseekerResume", data.data);
      });
    },

    rejectResume() {
      this.jobseekerRegistred = true;
      this.getResume();
      this.$bvModal.hide("resume-confirm");
    },

    confirmResume() {
      ApiService.setHeader("jobseeker");
      this.confirmLoading = true;
      ApiService.post("api/v2/jobseeker/resume/save-most-complete")
        .then((data) => {
          if (data.data.code == 201) {
            this.successToast(data.data.message);
            this.$emit("completeRegister", "hadResume");
          } else this.errorToast(data.data.message);
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
  },

  computed: {
    ...mapGetters(["jobseekerResume"]),

    completeStepName() {
      if (this.completeResumeStep == 1) return "آخرین مدرک تحصیلی";
      if (this.completeResumeStep == 2) return "آخرین سابقه شغلی";
      if (this.completeResumeStep == 3) return "مهارت‌ها";
      return null;
    },

    resendTime() {
      const minutes = Math.floor(this.timeRemaining / 60);
      const seconds = this.timeRemaining % 60;
      return `${0}${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    },
  },

  watch: {
    isCurrentlyEmployed() {
      this.resumeResult.jobExperience[0].jobEndDate = null;
    },

    noEducational(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.resumeResult.educationalBackground = [
            {
              educationMajor: null,
              educationDegree: null,
              educationUniversity: null,
            },
          ];
          this.completeResumeStep++;
        }, 100);
      }
    },

    noJob(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.resumeResult.jobExperience = [
            {
              jobTitle: null,
              jobCompanyName: null,
              jobStartDate: null,
              jobEndDate: null,
            },
          ];
          this.completeResumeStep++;
        }, 100);
      }
    },

    noSkill(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.resumeResult.skill = [
            {
              skillTitle: null,
              skillLevelId: null,
            },
          ];
        }, 100);
      }
    },

    currentMobile(newVal) {
      this.mobile.value = newVal;
    },
  },
};
</script>

<style></style>
